module.exports = __webpack_public_path__ + "img/_0.a97b979a.png";